/**
 * Hero copy variants for A/B testing.
 *
 * Each variant has a 2-line headline (line2 is highlighted in gradient),
 * a subhead, and a short identifier used in localStorage + analytics.
 *
 * Add a new variant by appending an entry to this array. The picker in
 * `utils/abVariant.js` will start serving it to ~1/N of new visitors.
 */
export const heroVariants = [
  {
    id: 'control',
    line1: 'Hire smarter.',
    line2: 'Hire faster.',
    subhead:
      'The only ATS built for high-volume staffing — bulk resume uploads, AI matching across 50,000+ candidates, single-screen Recruiter Command Center, and real-time pipeline metrics.',
  },
  {
    id: 'anti-excel',
    line1: 'Stop losing candidates',
    line2: 'to Excel.',
    subhead:
      "If your team manages 1,000+ candidates across multiple clients, spreadsheets are silently costing you placements. InterviewWala is the ATS Indian staffing firms switch to when Excel breaks.",
  },
  {
    id: 'respect-time',
    line1: 'The ATS that respects',
    line2: 'your half-day.',
    subhead:
      'Drag 100 PDFs, get 100 parsed candidates. Drag-and-drop kanban replaces 5 tabs of legacy ATS. Recruiters who switch save half a day every week.',
  },
];
